function importAll (r) {
  r.keys().forEach(r);
}


// import 'styles/styleguide/navigation/5.side-nav.sass'
// import 'styles/styleguide/forms/3.checkbox.sass'

import 'styles/styleguide/forms/12.image-upload.sass'

import 'styles/styleguide/elements/10.plain-text.sass'

// Карточки для рекомендация. Можно удалить если будут использоваться стили pinkman
import 'styles/styleguide/cards/2.card.sass'
import 'styles/styleguide/cards/3.card-recipe-special.sass'
import 'styles/styleguide/cards/19.card-footer.sass'
import 'styles/styleguide/cards/20.card-body.sass'

import 'styles/styleguide/cards/14.card-commercial.sass'

import 'styles/styleguide/elements/2.text-icon.sass'
import 'styles/styleguide/elements/3.badge.sass'
import 'styles/styleguide/elements/6.description-text.sass'
import 'styles/styleguide/elements/11.sharing.sass'
import 'styles/styleguide/elements/14.definition-list-table.sass'
import 'styles/styleguide/elements/15.default-link.sass'
import 'styles/styleguide/elements/17.rating.sass'
// Слишком большой, можно вырезать
import 'styles/styleguide/elements/21-22.entry-stats-person.sass'
import 'styles/styleguide/elements/25.slider-with-thumbs.sass'
import 'styles/styleguide/elements/39.slider-paginator.sass'

import 'styles/styleguide/elements/45.control-button.sass'
import 'styles/styleguide/elements/47.photo-preview.sass'
import 'styles/styleguide/elements/56.tv-show.sass'
import 'styles/styleguide/elements/60.scroll-top.sass'
import 'styles/styleguide/elements/67.popular-recipes.sass'
import 'styles/styleguide/elements/68.email-subscription.sass'
// Слишком большой, можно вырезать
import 'styles/styleguide/popups/1.popup.sass'


import 'styles/globals/3.tags.sass'
import 'styles/globals/4.comments.sass'
import 'styles/globals/5.recomendations.sass'
import 'styles/globals/6.forms.sass'
import 'styles/globals/7-8.scroll-box-emoji-list.sass'

import 'styles/recipes/0.globals.sass'

import 'styles/styleguide/comments/1.comment.sass'
import 'styles/styleguide/comments/2.show-all-comments.sass'


importAll(require.context('styles/styleguide/recipes/', true))
// import 'styles/styleguide/recipes/5.recipe-header.sass'
// import 'styles/styleguide/recipes/6.nutritional-value.sass'
// import 'styles/styleguide/recipes/10.recipe-author-block.sass'

import 'styles/vendor/mcustomscroll.css'

import 'styles/pieces/field-for-recipe.sass'
import 'styles/pieces/tooltip-show.sass'
import 'styles/pieces/slider-controls-thumb.sass'
import 'styles/pieces/ms-search.sass'
import 'styles/pieces/multiple-select.css'
import 'styles/pieces/nprogress.css'
import 'styles/pieces/emoji.sass'
import 'styles/pieces/popup-savetime.sass'
import 'styles/pieces/banners.sass'
import 'styles/pieces/sp.sass'
import 'styles/pieces/card-courses.sass'
import 'styles/pieces/slider-controls-report-popup.sass'
import 'styles/pieces/field-error.sass'



import "slick-carousel/slick/slick.css"
import "simplebar/simplebar.min.css"
